/* tslint:disable */
/* eslint-disable */
/**
 * Search API
 * Search
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { UpdatedField } from './';
import {
    UpdatedFieldFromJSON,
    UpdatedFieldFromJSONTyped,
    UpdatedFieldToJSON,
} from './';
import type { WriteOperationType } from './';
import {
    WriteOperationTypeFromJSON,
    WriteOperationTypeFromJSONTyped,
    WriteOperationTypeToJSON,
} from './';

/**
 * 
 * @export
 * @interface WriteOperation
 */
export interface WriteOperation {
    /**
     * 
     * @type {WriteOperationType}
     * @memberof WriteOperation
     */
    type: WriteOperationType;
    /**
     * 
     * @type {UpdatedField}
     * @memberof WriteOperation
     */
    field: UpdatedField;
}

/**
 * Check if a given object implements the WriteOperation interface.
 */
export function instanceOfWriteOperation(value: object): value is WriteOperation {
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('field' in value) || value['field'] === undefined) return false;
    return true;
}

export function WriteOperationFromJSON(json: any): WriteOperation {
    return WriteOperationFromJSONTyped(json, false);
}

export function WriteOperationFromJSONTyped(json: any, ignoreDiscriminator: boolean): WriteOperation {
    if (json == null) {
        return json;
    }
    return {
        
        'type': WriteOperationTypeFromJSON(json['type']),
        'field': UpdatedFieldFromJSON(json['field']),
    };
}

export function WriteOperationToJSON(value?: WriteOperation | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'type': WriteOperationTypeToJSON(value['type']),
        'field': UpdatedFieldToJSON(value['field']),
    };
}

